import { EnumEnvs } from '@library/store/config/config.interface';

declare global {
  interface Window {
      env: {
        envDomain: string
      }
  }
}
export const environment= {
  project: 'settings-velux',
  authUrl: "https://authbeta.velux-active.com",
  apiUrl: "https://appbeta.netatmo.net/api/",
  langsUrl: "/langs/",
  syncApiUrl: "https://app.netatmo.net/syncapi/v1/",
  cookiePrefix: "betaveluxactivecom",
  env: EnumEnvs.BETA,
  production: false
};
